// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Kuo2","location":"Header_location__1n5vY"};